import React from 'react';
import { AccountSetup as SharedAccountSetup } from '@ptth-web/shared-module';
import type { UserProfileAggregate } from '@leagueplatform/user-profile-api';
import { BasePage } from 'components/base-page/base-page.component';
import accountSetupAvatarPlaceholder from 'assets/account-setup-avatar-placeholder.svg';
import accountSetupAvatarEditBadge from 'assets/account-setup-avatar-edit-badge.svg';

export const AccountSetup = ({
  onComplete,
  initialProfile,
}: {
  onComplete: () => void;
  initialProfile: UserProfileAggregate;
}) => (
  <BasePage
    isPrivatePage={false}
    css={{
      background: '$surfaceBackgroundSecondary',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '$two',
    }}
  >
    <SharedAccountSetup
      onComplete={onComplete}
      initialProfile={initialProfile}
      avatarPlaceholderSrc={accountSetupAvatarPlaceholder}
      avatarEditBadgeSrc={accountSetupAvatarEditBadge}
    />
  </BasePage>
);
